export const routes = [
  { path: '/interactive-path', component: () => import('@/app/modules/MemberNavigator/views/InteractivePath.vue') },
  {
    path: '/interactive-path-steps/:id',
    component: () => import('@/app/modules/MemberNavigator/views/InteractivePathSteps.vue'),
  },
  { path: '/review-changes/list', component: () => import('@/app/modules/MemberNavigator/views/ReviewChanges.vue') },
  {
    path: '/review-changes/list/item/:id',
    name: 'ReviewItem',
    component: () => import('@/app/modules/MemberNavigator/views/ReviewItem.vue'),
  },
];
